module.exports = __webpack_public_path__ + "/images/shop/carpage-car-selection/hsn_tsn2.jpg";